import React from 'react';
import PropTypes from 'prop-types';
import FilterPanel from '../common/FilterPanel';
import TemplatesFilterContainer from './TemplatesFilterContainer';

const TemplatesFilterPanel = ({isFilterPanelOpen, closeFilterPanel, isFiltered, resetFilters, container}) => (
  <FilterPanel
    closeFilterPanel={closeFilterPanel}
    isFilterPanelOpen={isFilterPanelOpen}
    isFiltered={isFiltered}
    resetFilters={resetFilters}
  >
    <TemplatesFilterContainer container={container} />
  </FilterPanel>
);

TemplatesFilterPanel.displayName = 'TemplatesFilterPanel';

TemplatesFilterPanel.propTypes = {
  isFilterPanelOpen: PropTypes.bool.isRequired,
  isFiltered: PropTypes.bool.isRequired,
  closeFilterPanel: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  container: PropTypes.object
};

export default TemplatesFilterPanel;
